import { Space } from '@looker/components';
import type React from 'react';
import { ErrorDisplay } from '../../../../../components/ErrorDisplay/ErrorDisplay';

interface FilterSearchNoResultsProps {
  message?: string;
}

const DEFAULT_MESSAGE = 'No result found. Try refining your search.';

export const FilterSearchNoResults: React.FC<FilterSearchNoResultsProps> = ({ message = DEFAULT_MESSAGE }) => (
  <Space height="100%" maxWidth="300px" margin="auto">
    <ErrorDisplay text={message} />
  </Space>
);
